import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import { DownloadOutlined } from '@ant-design/icons';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const DesignHoldRevokeAnalysis = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [revokeStore, setRevokeStore] = useState([]);
    const [storeMonth, setStoreMonth] = useState([]);
    const [revokeCommonExpCenter, setRevokeExpCenter] = useState([])
    const [commonRevokeLocation, setRevokeLocation] = useState([])
    const [storeRevokeDateFilter, setRevokePivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedRevokeExperienceCenter, setSelectedRevokeExperienceCenter] = useState([])
    const [selectedRevokeLocation, setSelectedRevokeLocation] = useState([])
    const [selectedRevokeValue, setSelectedRevokeValue] = useState("");
    const [showRevokeDetailedModal, setShowRevokeDetailedModal] = useState(false);
    const [csvrevokeData, setCsvRevokeData] = useState([]);
    const csvRevokeButtonRef = useRef(null);
    const [popRevokeMonthData, setPopRevokeMonthData] = useState([]);
    const [selectedRevokeRole, setSelectedRevokeRole] = useState('');
    const [usersRevokeData, setUsersRevokeData] = useState([]);
    const [selectedRevokeUsers, setSelectedRevokeUsers] = useState([]);
    const [selectRevokeLost, setSeletRevokeLost] = useState('')
    const [selectedRevokeDepartment, setSelectedRevokeDepartment] = useState("")
    const [searchRevokeInput, setSearchRevokeInput] = useState("")
    const [selectedRevokeSearchType, setSelectedRevokeSearchType] = useState("");
    const [designHoldReason, setDesignHoldReason] = useState([]);
    const [designHoldStage, setDesignHoldStage] = useState([])
    const searchRevokeTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [tableCsvData, setTableCsvData] = useState([]);
    const [revokeMonthTableCsvData, setRevokeMonthTableCsvData] = useState([]);
    const revokeMonthTableCsvButtonRef = useRef(null);
    const [triggerRevokeMonthDownload, setTriggerRevokeMonthDownload] = useState(false);
    const [revokeYearTableCsvData, setRevokeYearTableCsvData] = useState([]);
    const revokeYearTableCsvButtonRef = useRef(null);
    const [triggerRevokeYearDownload, setTriggerRevokeYearDownload] = useState(false);
    const tableCsvButtonRef = useRef(null);

    const roleToPivotMap = {
        [ROLENAME.DGM_Sales]: 'value',
        [ROLENAME.SalesManager]: 'value',
        [ROLENAME.AssistantSalesManager]: 'value',
        [ROLENAME.SalesUser]: 'value',
        [ROLENAME.DGM_Design]: 'overallsummary',
        [ROLENAME.OperationDesignManager]: 'overallsummary',
        [ROLENAME.AssistantDesignManager]: 'overallsummary',
        [ROLENAME.DesignUser]: 'overallsummary',
        default: 'value',
    };
    const initialPivot = userDetails.roles.reduce((pivotValue, role) => {
        return roleToPivotMap[role.name] || pivotValue;
    }, roleToPivotMap.default);
   
    const [revokePivot, setRevokePivot] = useState(initialPivot);
    const [ innerElYearDate , setInnerElYearDate]=  useState({
        experienceCenterName: "Grand Total",
        name : "Grand Total"
    })
    const [commonDesignHoldReason, setCommonDesignHoldReason] = useState([
        'Possesion Delay',
        'Cx not available',
        'Cx having Financial Issue',
        'Cx wants to put the projects on hold',
        'Probable Loss',
        'Others',
    ])

    const [commonDesignHoldStage, setCommonDesignHoldStage] = useState([
        'Design-Hold Pending Approval',
        'Design-Hold'
    ])

    useEffect(() => {
        expCentersRevoke();
        revokeLocations();
        fetchUsersData();
        checkPivot('designHoldRevokeAnalysis')
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager  || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            setSelectedRevokeRole(ROLENAME.SalesUser)
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            setSelectedRevokeRole(ROLENAME.DesignUser)
        } else {
            setSelectedRevokeRole("ALL")
        }
    }, []);

    const revokeHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designHoldStage", label: "Design-Hold Stage" },
        { key: "designHoldReason", label: "Design-Hold Reason" },
        { key: "probableRestartingDate", label: "Probable Date for Restarting the Designing" },
        { key: "probableDesignSignOffDate", label: "Probable Date of Design Sign-off" },
        { key: "currentStage", label: "Current Stage" },
        { key: "department", label: "Department" },
        { key: "designUser", label: "Current Designer" },
        { key: "designAssistantManager", label: "Current Assistant Design Manager " },
        { key: "designManager", label: "Current Operation Design Manager" },
        { key: "dealActivityDate", label: "Recent Deal Activity Date" },
        { key: "dealActivity", label: "Recent Deal Activity Comment" },
        { key: "customerApprovalStatus", label: "Customer Approval Status" },
    ];

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "valueInr", label: "Value (INR)" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designHoldStage", label: "Design-Hold Stage" },
        { key: "designHoldReason", label: "Design-Hold Reason" },
        { key: "probableRestartingDate", label: "Probable Date for Restarting the Designing" },
        { key: "probableDesignSignOffDate", label: "Probable Date of Design Sign-off" },
        { key: "adm", label: "ADM" },
        { key: "operationDesignManager", label: "Operation Design Manager" },
    ];

        // Trigger revoke month table download when data is ready
        useEffect(() => {
            if (triggerRevokeMonthDownload && revokeMonthTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (revokeMonthTableCsvButtonRef.current?.link) {
                        try {
                            revokeMonthTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props?.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerRevokeMonthDownload(false);
                    } else {
                        // Retry if link is not ready
                        setTimeout(() => {
                            if (revokeMonthTableCsvButtonRef.current?.link) {
                                revokeMonthTableCsvButtonRef.current.link.click();
                                setTriggerRevokeMonthDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                
                return () => clearTimeout(timer);
            }
        }, [triggerRevokeMonthDownload, revokeMonthTableCsvData]);
    
        // Trigger revoke year table download when data is ready
        useEffect(() => {
            if (triggerRevokeYearDownload && revokeYearTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (revokeYearTableCsvButtonRef.current?.link) {
                        try {
                            revokeYearTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props?.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerRevokeYearDownload(false);
                    } else {
                        // Retry if link is not ready
                        setTimeout(() => {
                            if (revokeYearTableCsvButtonRef.current?.link) {
                                revokeYearTableCsvButtonRef.current.link.click();
                                setTriggerRevokeYearDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                
                return () => clearTimeout(timer);
            }
        }, [triggerRevokeYearDownload, revokeYearTableCsvData]);

    const tableCsvDownloadHandler = () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popRevokeMonthData.length; i++) {
                const data = popRevokeMonthData[i];
                let obj = {
                    serialNo: i + 1,
                    projectCode: data?.leadId?.erpProjectNo || "N/A",
                    leadNumber: data?.leadId?.lead_no || "N/A",
                    clientName: data?.leadId?.customerId?.name || "N/A",
                    valueInr: data?.leadId?.staticSalesWonBudget || "N/A",
                    location: data?.salesExpCenter?.locationId?.name || "N/A",
                    expCtrName: data?.salesExpCenter?.name || "N/A",
                    salesWonDate: data?.SalesWonDate ? moment(data?.SalesWonDate).format("DD-MM-YYYY") : "-",
                    designHoldStage: data?.leadId?.designStatus || "NA",
                    designHoldReason: data?.leadId?.designHoldSelectedTypes || "NA",
                    probableRestartingDate: data?.leadId?.proposedDesignStartDate ? moment(data?.leadId?.proposedDesignStartDate).format("DD-MM-YYYY") : "NA",
                    probableDesignSignOffDate: data?.leadId?.probableDesignSignOffDate ? moment(data?.leadId?.probableDesignSignOffDate).format("DD-MM-YYYY") : "NA",
                    adm: data?.designAssistantManager?.name || "NA",
                    operationDesignManager: data?.designManager?.name || "NA",
                };
                csvArray.push(obj);
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            });
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const csvDownloadRevokeHandler = async (data) => {
        setLoading(true);
        try {
                let csvArray = [];
                for (let i = 0; i < popRevokeMonthData.length; i++) {
                    let obj = {
                        serialNo: i + 1,
                        projectCode: popRevokeMonthData[i]?.leadId?.erpProjectNo || "N/A",
                        leadNumber: popRevokeMonthData[i]?.leadId?.lead_no || "N/A",
                        clientName: popRevokeMonthData[i]?.leadId?.customerId?.name,
                        totalValue:  popRevokeMonthData[i]?.leadId?.staticSalesWonBudget ? popRevokeMonthData[i]?.leadId?.staticSalesWonBudget : "-",
                        location: popRevokeMonthData[i]?.salesExpCenter?.locationId?.name || '-',
                        expCtrName: popRevokeMonthData[i]?.salesExpCenter?.name,
                        salesWonDate: popRevokeMonthData[i]?.SalesWonDate ? moment(popRevokeMonthData[i]?.SalesWonDate).format("DD-MM-YYYY") : "-",
                        designUser: popRevokeMonthData[i]?.leadId?.designUser ? popRevokeMonthData[i]?.leadId?.designUser?.name : 'NA',
                        designManager: popRevokeMonthData[i]?.leadId?.designManager ? popRevokeMonthData[i]?.leadId?.designManager?.name : 'NA',
                        designDGM: popRevokeMonthData[i]?.designDGM ? popRevokeMonthData[i]?.designDGM?.name : 'NA',
                        designAssistantManager: popRevokeMonthData[i]?.leadId?.designAssistantManager ? popRevokeMonthData[i]?.leadId?.designAssistantManager?.name : 'NA',
                        currentStage: popRevokeMonthData[i]?.leadId?.currentStage ? popRevokeMonthData[i]?.leadId?.currentStage : 'NA',
                        department: popRevokeMonthData[i]?.leadId?.departmentId?.name ? popRevokeMonthData[i]?.leadId?.departmentId?.name : 'NA',
                        designStage: popRevokeMonthData[i]?.stage ? popRevokeMonthData[i]?.stage : "NA",
                        reasonDesignHold: popRevokeMonthData[i]?.leadId?.designHoldSelectedTypes ? popRevokeMonthData[i]?.leadId?.designHoldSelectedTypes : '-',
                        probableRestartingDate: popRevokeMonthData[i].leadId?.proposedDesignStartDate ?
                            moment(popRevokeMonthData[i]?.leadId?.proposedDesignStartDate).format('DD-MM-YYYY') : "-",
                        probableDesignSignOffDate: popRevokeMonthData[i].leadId?.probableDesignSignOffDate ?
                            moment(popRevokeMonthData[i].leadId?.probableDesignSignOffDate).format('DD-MM-YYYY') : "-",
                        dealActivityDate: popRevokeMonthData[i]?.latestDealActivityDate ? moment(popRevokeMonthData[i]?.latestDealActivityDate).format("DD-MM-YYYY") : "-",
                        dealActivity: popRevokeMonthData[i]?.latestDealActivity ? popRevokeMonthData[i]?.latestDealActivity : "NA",
                        customerApprovalStatus: popRevokeMonthData[i]?.leadId?.designHoldStatusApproval?.customerApproval === "Approved"
                            ? "Yes"
                            : "No",
                        adm: popRevokeMonthData[i]?.designAssistantManager ? popRevokeMonthData[i]?.designAssistantManager?.name : "-",
                        operationDM: popRevokeMonthData[i]?.designManager ? popRevokeMonthData[i]?.designManager?.name : "-",
                        stage: popRevokeMonthData[i].stage ? popRevokeMonthData[i].stage : "NA",
                        designHoldStage: popRevokeMonthData[i].leadId.designStatus ? popRevokeMonthData[i].leadId.designStatus  : 'NA',
                        designHoldReason: popRevokeMonthData[i].leadId.designHoldSelectedTypes ? popRevokeMonthData[i].leadId.designHoldSelectedTypes  : 'NA'
                    };
                    csvArray.push(obj);
                    // obj = {
                    //     serialNo: "",
                    //     projectCode: "",
                    //     clientName: "",
                    //     totalValue: "",
                    //     expCtrName: "",
                    //     salesWonDate: "",
                    //     internalDesignSignOffDate: "",
                    //     designSignOffDate: "",
                    //     materialDeliveryDate: "",
                    //     actualCompletionDate: "",
                    //     HoldRevocationDate: "",
                    // };
                    // csvArray.push(obj);
                }
            setCsvRevokeData(csvArray);
            downloadRevokeExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

        // Function to generate CSV data for revoke year analysis table
        const generateRevokeYearTableCsvData = () => {
            try {
                if (!revokeStore || revokeStore.length === 0) {
                    return [];
                }
    
                const grandTotalIdx = revokeStore?.findIndex(item => item?.name === "Grand Total");
                if (grandTotalIdx === -1 || !revokeStore[grandTotalIdx]?.yearlyGrandTotal) {
                    return [];
                }
    
                // Use the EXACT same data structures as the table uses
                const localExpCenterRevokeData = {};
                revokeStore.forEach((el) => {
                    if (!localExpCenterRevokeData[el.experienceCenterName]) {
                        localExpCenterRevokeData[el.experienceCenterName] = [];
                    }
                    localExpCenterRevokeData[el.experienceCenterName].push(el);
                });
    
                const localUniqueexperienceCenterRevokeNames = Array.from(new Set(revokeStore.map((el) => el.experienceCenterName)));
    
                if (localUniqueexperienceCenterRevokeNames.length === 0) {
                    return [];
                }
    
                const csvRows = [];
    
                // Build header row - match table structure exactly
                // Build header columns in the same order as data rows are displayed
                // Table iterates: uniqueexperienceCenterRevokeNames.map -> expCenterRevokeData[experienceCenterName].map
                const headerRow = {
                    "Revoke Year": ""
                };
    
                // Build header columns to match data row structure exactly (same iteration pattern)
                localUniqueexperienceCenterRevokeNames.forEach((experienceCenterName) => {
                    if (localExpCenterRevokeData[experienceCenterName]) {
                        localExpCenterRevokeData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                                headerRow[`${innerEl.expCenterCode} - Count`] = "";
                                headerRow[`${innerEl.expCenterCode} - Value`] = "";
                            }
                        });
                    }
                });
                headerRow["Grand Total - Count"] = "";
                headerRow["Grand Total - Value"] = "";
                csvRows.push(headerRow);
    
                // Add yearly data rows - match table iteration exactly
                // Table iterates: uniqueexperienceCenterRevokeNames.map -> expCenterRevokeData[experienceCenterName].map
                revokeStore[grandTotalIdx].yearlyGrandTotal.forEach((month) => {
                    const row = {
                        "Revoke Year": `${month.year} - (Jan-Dec)`
                    };
    
                    // Match table's iteration pattern exactly
                    localUniqueexperienceCenterRevokeNames.forEach((experienceCenterName) => {
                        if (localExpCenterRevokeData[experienceCenterName]) {
                            localExpCenterRevokeData[experienceCenterName].forEach((innerEl) => {
                                if (innerEl.expCenterCode) {
                                    const yearlyData = innerEl.yearlyGrandTotal?.find(
                                        (entry) => entry.year === month.year
                                    );
                                    
                                    // Format values directly (matching designHoldAnalysis approach)
                                    row[`${innerEl.expCenterCode} - Count`] = formatNumberToTwoDecimalPlaces(yearlyData?.count || 0);
                                    row[`${innerEl.expCenterCode} - Value`] = formatNumberToTwoDecimalPlaces(yearlyData?.totalGrandTotal || 0);
                                }
                            });
                        }
                    });
    
                    // Grand Total for this year - sum of all displayed cells (matching table calculation)
                    const grandTotalCount = Object.keys(row).reduce((sum, key) => {
                        return (key !== "Revoke Year" && key.endsWith(" - Count")) ? sum + (parseFloat(row[key]) || 0) : sum;
                    }, 0);
                    const grandTotalValue = Object.keys(row).reduce((sum, key) => {
                        return (key !== "Revoke Year" && key.endsWith(" - Value")) ? sum + (parseFloat(row[key]) || 0) : sum;
                    }, 0);
                    row["Grand Total - Count"] = formatNumberToTwoDecimalPlaces(grandTotalCount);
                    row["Grand Total - Value"] = formatNumberToTwoDecimalPlaces(grandTotalValue);
                    csvRows.push(row);
                });
    
                // Add Grand Total row - match table structure exactly
                // Table iterates: uniqueexperienceCenterRevokeNames.map and sums by experienceCenterName
                const grandTotalRow = {
                    "Revoke Year": "Grand Total"
                };
    
                // Match table's Grand Total row calculation
                // Table shows totals per experienceCenterName, but we need to map to expCenterCode columns
                localUniqueexperienceCenterRevokeNames.forEach((experienceCenterName) => {
                    // Distribute totals across expCenterCodes for this experienceCenterName
                    if (localExpCenterRevokeData[experienceCenterName]) {
                        localExpCenterRevokeData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                                // Sum all items with this expCenterCode (matching table's per-expCenterCode display)
                                const expCenterCount = revokeStore.reduce((sum, el) => 
                                    sum + (el?.expCenterCode === innerEl.expCenterCode ? (el?.count || 0) : 0), 0
                                );
                                const expCenterValue = revokeStore.reduce((sum, el) => 
                                    sum + (el?.expCenterCode === innerEl.expCenterCode ? (el?.grandTotal || 0) : 0), 0
                                );
                                
                                grandTotalRow[`${innerEl.expCenterCode} - Count`] = formatNumberToTwoDecimalPlaces(expCenterCount);
                                grandTotalRow[`${innerEl.expCenterCode} - Value`] = formatNumberToTwoDecimalPlaces(expCenterValue);
                            }
                        });
                    }
                });
    
                // Grand Total for grand total row - sum of all displayed cells
                const overallGrandTotalCount = Object.keys(grandTotalRow).reduce((sum, key) => {
                    return (key !== "Revoke Year" && key.endsWith(" - Count")) ? sum + (parseFloat(grandTotalRow[key]) || 0) : sum;
                }, 0);
                const overallGrandTotalValue = Object.keys(grandTotalRow).reduce((sum, key) => {
                    return (key !== "Revoke Year" && key.endsWith(" - Value")) ? sum + (parseFloat(grandTotalRow[key]) || 0) : sum;
                }, 0);
                grandTotalRow["Grand Total - Count"] = formatNumberToTwoDecimalPlaces(overallGrandTotalCount);
                grandTotalRow["Grand Total - Value"] = formatNumberToTwoDecimalPlaces(overallGrandTotalValue);
                csvRows.push(grandTotalRow);
    
                return csvRows;
            } catch (error) {
                console.error("Error generating revoke year table CSV:", error);
                return [];
            }
        };
    
        // Function to generate CSV data for revoke month analysis table
        const generateRevokeMonthTableCsvData = () => {
            try {
                if (!storeMonth || storeMonth.length === 0 || !storeMonth[0]?.monthlyGrandTotal) {
                    return [];
                }
    
                const localExpCenterDataMonth = {};
                storeMonth.forEach((el) => {
                    if (!localExpCenterDataMonth[el.experienceCenterName]) {
                        localExpCenterDataMonth[el.experienceCenterName] = [];
                    }
                    localExpCenterDataMonth[el.experienceCenterName].push(el);
                });
    
                const localUniqueexperienceCenterNamesMonth = Array.from(new Set(storeMonth.map((el) => el.experienceCenterName)));
                const localUniqueexperienceCenterCodeMonth = Array.from(new Set(storeMonth.map((el) => el.expCenterCode)));
                const headerExpCenters = storeMonth.slice(0, localUniqueexperienceCenterCodeMonth.length - 1);
    
                if (localUniqueexperienceCenterNamesMonth.length === 0) {
                    return [];
                }
    
                const csvRows = [];
    
                // Build header row - match table structure exactly
                const headerRow = {
                    "Revoke Month": ""
                };
    
                // Add exp center code columns with Count and Value
                headerExpCenters.forEach((expCenter) => {
                    if (expCenter.expCenterCode) {
                        headerRow[`${expCenter.expCenterCode} - Count`] = "";
                        headerRow[`${expCenter.expCenterCode} - Value`] = "";
                    }
                });
                headerRow["Grand Total - Count"] = "";
                headerRow["Grand Total - Value"] = "";
                csvRows.push(headerRow);
    
                // Add monthly data rows - match table structure exactly
                storeMonth[0].monthlyGrandTotal.forEach((month) => {
                    const row = {
                        "Revoke Month": `${month.monthName.slice(0, 3)}-${month.year % 100} `
                    };
    
                    // Add data matching table structure exactly
                    // Table iterates: uniqueexperienceCenterNamesMonth -> expCenterDataMonth[experienceCenterName] -> innerEl
                    localUniqueexperienceCenterNamesMonth.forEach((experienceCenterName) => {
                        if (localExpCenterDataMonth[experienceCenterName]) {
                            localExpCenterDataMonth[experienceCenterName].forEach((innerEl) => {
                                if (innerEl.expCenterCode) {
                                    const monthData = innerEl.monthlyGrandTotal?.find(
                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                    );
                                    
                                    // If this expCenterCode already exists, sum the values (handling duplicates)
                                    if (row[`${innerEl.expCenterCode} - Count`] !== undefined) {
                                        row[`${innerEl.expCenterCode} - Count`] += (monthData?.count || 0);
                                        row[`${innerEl.expCenterCode} - Value`] += (monthData?.totalGrandTotal || 0);
                                    } else {
                                        row[`${innerEl.expCenterCode} - Count`] = monthData?.count || 0;
                                        row[`${innerEl.expCenterCode} - Value`] = monthData?.totalGrandTotal || 0;
                                    }
                                }
                            });
                        }
                    });
    
                    // Calculate Grand Total - sum of all displayed cells
                    const grandTotalCount = Object.keys(row).reduce((sum, key) => {
                        return (key !== "Revoke Month" && key.endsWith(" - Count")) ? sum + (parseFloat(row[key]) || 0) : sum;
                    }, 0);
                    const grandTotalValue = Object.keys(row).reduce((sum, key) => {
                        return (key !== "Revoke Month" && key.endsWith(" - Value")) ? sum + (parseFloat(row[key]) || 0) : sum;
                    }, 0);
                    row["Grand Total - Count"] = formatNumberToTwoDecimalPlaces(grandTotalCount);
                    row["Grand Total - Value"] = formatNumberToTwoDecimalPlaces(grandTotalValue);
                    csvRows.push(row);
                });
    
                // Add Grand Total row - match table structure exactly
                const grandTotalRow = {
                    "Revoke Month": "Grand Total"
                };
    
                // Calculate Grand Total per expCenterCode (matching CSV column structure)
                headerExpCenters.forEach((expCenter) => {
                    // Sum all items with this expCenterCode
                    const totalCount = storeMonth.reduce((total, el) => {
                        return total + (el.expCenterCode === expCenter.expCenterCode ? (el.count || 0) : 0);
                    }, 0);
                    const totalValue = storeMonth.reduce((total, el) => {
                        return total + (el.expCenterCode === expCenter.expCenterCode ? (el.grandTotal || 0) : 0);
                    }, 0);
                    grandTotalRow[`${expCenter.expCenterCode} - Count`] = formatNumberToTwoDecimalPlaces(totalCount);
                    grandTotalRow[`${expCenter.expCenterCode} - Value`] = formatNumberToTwoDecimalPlaces(totalValue);
                });
    
                // Overall Grand Total - sum of all displayed cells in the Grand Total row
                const overallGrandTotalCount = Object.keys(grandTotalRow).reduce((sum, key) => {
                    return (key !== "Revoke Month" && key.endsWith(" - Count")) ? sum + (parseFloat(grandTotalRow[key]) || 0) : sum;
                }, 0);
                const overallGrandTotalValue = Object.keys(grandTotalRow).reduce((sum, key) => {
                    return (key !== "Revoke Month" && key.endsWith(" - Value")) ? sum + (parseFloat(grandTotalRow[key]) || 0) : sum;
                }, 0);
                grandTotalRow["Grand Total - Count"] = formatNumberToTwoDecimalPlaces(overallGrandTotalCount);
                grandTotalRow["Grand Total - Value"] = formatNumberToTwoDecimalPlaces(overallGrandTotalValue);
                csvRows.push(grandTotalRow);
    
                return csvRows;
            } catch (error) {
                console.error("Error generating revoke month table CSV:", error);
                return [];
            }
        };

    const downloadRevokeExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvRevokeButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    const expCenterRevokeData = {};
    revokeStore.forEach((el) => {
        if (!expCenterRevokeData[el.experienceCenterName]) {
            expCenterRevokeData[el.experienceCenterName] = [];
        }
        expCenterRevokeData[el.experienceCenterName].push(el);
    });

    const expCenterDataMonth = {};
    storeMonth.forEach((el) => {
        if (!expCenterDataMonth[el.experienceCenterName]) {
            expCenterDataMonth[el.experienceCenterName] = [];
        }
        expCenterDataMonth[el.experienceCenterName].push(el);
    });

    const uniqueexperienceCenterRevokeCode = Array.from(new Set(revokeStore.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterRevokeNames = Array.from(new Set(revokeStore.map((el) => el.experienceCenterName)));

    const uniqueexperienceCenterCodeMonth = Array.from(new Set(storeMonth.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNamesMonth = Array.from(new Set(storeMonth.map((el) => el.experienceCenterName)));

    const expCentersRevoke = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setRevokeExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const revokeLocations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setRevokeLocation(matchedUsers);
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const designHoldRevokeAnalysisData = async (addLocation, addExpCenter, usersRevokeData, selectedRevokeSearchType, searchRevokeInput, designHoldReason, designHoldStage ) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterRevokeData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersRevokeData?.users && usersRevokeData?.users.length !== 0) || (selectedRevokeUsers && selectedRevokeUsers.length !== 0)) {
            users = usersRevokeData?.users?.map((el) => el._id) || selectedRevokeUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeRevokeDateFilter.startDate,
            endDate: storeRevokeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterRevokeData ? expCenterRevokeData : "",
            tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            lost: selectRevokeLost !== "" ? selectRevokeLost : "",
            pivotValue: 'designHoldRevokeAnalysis',
            designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
            designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage,
            searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
            search: searchRevokeInput ? searchRevokeInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.AssistantSalesManager)) {
            obj.selectedRole = usersRevokeData?.role ? usersRevokeData?.role : ROLENAME.AssistantSalesManager
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersRevokeData?.role ? usersRevokeData?.role : ROLENAME.SalesUser
        } else {
            obj.selectedRole = usersRevokeData?.role ? usersRevokeData?.role : (selectedRevokeRole ? selectedRevokeRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDesignRevokeDataBasedOnExpCenter(obj);
            let res = await HttpService.getDesignHoldRevokeAnanlysisMonthBasedData(obj);
            setRevokeStore(response.data);
            setStoreMonth(res.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const checkPivot = async (value) => {
        setRevokePivot(value)
         if (value === 'designHoldRevokeAnalysis') {
            designHoldRevokeAnalysisData()
            setSelectedRevokeExperienceCenter([])
            setSelectedRevokeUsers([])
            setSelectedRevokeRole("ALL")
            setSearchRevokeInput("")
            setSelectedRevokeSearchType("")
            handleSelectRevokeRoles(null, ROLENAME.DesignUser)
        } 
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storeRevokePivotDate = (e) => {
        const { name, value } = e.target
        setRevokePivotDatefilters({ ...storeRevokeDateFilter, [name]: value })
    }
    const handlePivotRevokeDateFilter = () => {
            designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, selectedRevokeUsers, selectedRevokeSearchType, searchRevokeInput, designHoldReason, designHoldStage )
    }

    const handleRevokeSearchType = (value) => {
        setSelectedRevokeSearchType(value)
        setSearchRevokeInput('')
    }

    const handleRevokeSearch = async (value) => {
         designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, selectedRevokeUsers, selectedRevokeSearchType, searchRevokeInput, designHoldReason, designHoldStage )
    }

    const handleRevokeKeyDown = (event) => {
        if (event.key === 'Enter' && selectedRevokeSearchType && searchRevokeInput) {
            handleRevokeSearch(searchRevokeInput.toUpperCase());
        }
    };

    const handleSelectRevokeRoles = async (event, role) => {
        setSelectedRevokeUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRevokeRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = revokePivot
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            if (!role) {
              designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, obj, selectedRevokeSearchType, searchRevokeInput, designHoldReason, designHoldStage )
            }
            setUsersRevokeData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {}
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.role = ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.role = ROLENAME.DesignUser            
        } else {
            obj.role = "ALL"
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersRevokeData(response.data)
        } catch (error) {
            console.log(error,"error")
        }
    }
    
    const handleMultipleRevokeExpData = (e, newvalue) => {
        setSelectedRevokeExperienceCenter(newvalue)
        handleRevokeExpData(newvalue)
    }

    const handleMultipleDesignHoldReason = (e, reasonValue) => {
        designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, selectedRevokeUsers, selectedRevokeSearchType, searchRevokeInput,reasonValue, designHoldStage );
        setDesignHoldReason(reasonValue)
    }

    const handleMultipleDesignHoldStage = async (e, stageValue) => {
       designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, selectedRevokeUsers, selectedRevokeSearchType, searchRevokeInput, designHoldReason, stageValue );
       setDesignHoldStage(stageValue);
    };

    const handleRevokeExpData = async (newvalue) => {
        props.setLoading(true);
            await designHoldRevokeAnalysisData(selectedRevokeLocation, newvalue, selectedRevokeUsers, selectedRevokeSearchType, searchRevokeInput, designHoldReason, designHoldStage )
        props.setLoading(false);
    }

    const handleRevokeMultipleLocationData = (e, newvalue) => {
        setSelectedRevokeLocation(newvalue)
        handleRevokeLocationData(newvalue)
    }
    const handleRevokeLocationData = async (newvalue) => {
        props.setLoading(true);
        await designHoldRevokeAnalysisData(newvalue, selectedRevokeExperienceCenter, selectedRevokeUsers, selectedRevokeSearchType, searchRevokeInput)
        props.setLoading(false);
    }

    const handleRevokeMultipleUsers = (e, newvalue) => {
        setSelectedRevokeUsers(newvalue)
        handleRevokeUsersData(newvalue)
    }

    const handleRevokeUsersData = async (newvalue) => {
        props.setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRevokeRole
        }
        await designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, obj, selectedRevokeSearchType, searchRevokeInput, designHoldReason, designHoldStage )
        props.setLoading(false);
    }

    const clearRevokeDateFilter = () => {
        setSearchRevokeInput("")
        setSelectedRevokeSearchType("")
        designHoldRevokeAnalysisData(selectedRevokeLocation, selectedRevokeExperienceCenter, selectedRevokeUsers, "", "", designHoldReason, designHoldStage)
    }

    const getDataBasedOnClickDesignHoldRevoke = async (e, month, innerEl, val) => {
        let obj = {}
        let users = ''
        let expCenterRevokeData =
            selectedRevokeExperienceCenter && selectedRevokeExperienceCenter.length > 0
                ? selectedRevokeExperienceCenter.map((el) => el._id)
                : "";
        let locationData = selectedRevokeLocation && selectedRevokeLocation.length > 0 ? selectedRevokeLocation.map((el) => el._id) : "";
        if (selectedRevokeUsers && selectedRevokeUsers.length !== 0) {
            users = selectedRevokeUsers?.map((el) => el._id)
        }
      if(val === 'designHoldRevokeAnalysis'){
            obj = {
                _id: { year: month.year, startDate:storeRevokeDateFilter.startDate, endDate: storeRevokeDateFilter.endDate },
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterRevokeData,
                tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                lost: selectRevokeLost !== "" ? selectRevokeLost : "",
                pivotValue: 'designHoldRevokeAnalysis',
                selectedRole: selectedRevokeRole ? selectedRevokeRole : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                users: users ? users : "",
                searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
                search: searchRevokeInput !== "" ? searchRevokeInput.toUpperCase() : "",
                designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
                designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage
            }
        } else if(val === 'revokeTotal'){
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length-1].monthNumber, endtYear: month[month.length-1].year, startDate: storeRevokeDateFilter.startDate, endDate: storeRevokeDateFilter.endDate },
                    selectedExperienceCenter: expCenterRevokeData,
                    tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
                    selectedLocation: locationData ? locationData : "",
                    lost: selectRevokeLost !== "" ? selectRevokeLost : "",
                    pivotValue: 'designHoldRevokeAnalysis',
                    selectedRole: selectedRevokeRole ? selectedRevokeRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
                    search: searchRevokeInput !== "" ? searchRevokeInput.toUpperCase() : "",
                    designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
                    designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage 
                }
            } else {
                let expCenter;
                for (let i = 0; i < revokeStore.length; i++) {
                    if (revokeStore[i].experienceCenterName === innerEl) {
                        expCenter = revokeStore[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year, startDate: storeRevokeDateFilter.startDate, endDate: storeRevokeDateFilter.endDate },
                    selectedExperienceCenter: expCenter,
                    tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
                    selectedLocation: locationData ? locationData : "",
                    lost: selectRevokeLost !== "" ? selectRevokeLost : "",
                    pivotValue: 'designHoldRevokeAnalysis',
                    selectedRole: selectedRevokeRole ? selectedRevokeRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
                    search: searchRevokeInput !== "" ? searchRevokeInput.toUpperCase() : "",
                    designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
                    designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage
                }
            }

        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDataBasedClickDesignHoldRevoke(obj);
            let sortedData = response.data.sort((a, b) => {
                return new Date(a.proposedDesignStartDate) - new Date(b.proposedDesignStartDate);
            });
            setPopRevokeMonthData(sortedData);
            setShowRevokeDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }
    const grandTotalIndex = revokeStore?.findIndex(item => item?.name === "Grand Total");


    // get data based on month design-hold revoke analysis
    const getDataBasedOnClickMonthCount = async (e, month, innerEl, val) => {
        let obj = {}
        let users = ''
        let expCenterRevokeData = selectedRevokeExperienceCenter && selectedRevokeExperienceCenter.length > 0 ? selectedRevokeExperienceCenter.map((el) => el._id): "";
        let locationData = selectedRevokeLocation && selectedRevokeLocation.length > 0 ? selectedRevokeLocation.map((el) => el._id) : "";
        if (selectedRevokeUsers && selectedRevokeUsers.length !== 0) {
            users = selectedRevokeUsers?.map((el) => el._id)
        }
        if (val === 'value') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterRevokeData,
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
                lost: selectRevokeLost !== "" ? selectRevokeLost : "",
                pivotValue: 'designHoldRevokeAnalysis',
                selectedRole: selectedRevokeRole ? selectedRevokeRole : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                users: users ? users : "",
                searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
                search: searchRevokeInput !== "" ? searchRevokeInput.toUpperCase() : "",
                designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
                designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterRevokeData,
                    selectedLocation: locationData,

                    tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
                    lost: selectRevokeLost !== "" ? selectRevokeLost : "",
                    pivotValue: 'designHoldRevokeAnalysis',
                    selectedRole: selectedRevokeRole ? selectedRevokeRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    users: users ? users : "",
                    userLocation: userDetails.selectedLocation,
                    searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
                    search: searchRevokeInput !== "" ? searchRevokeInput.toUpperCase() : "",
                    designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
                    designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage 
                }
            } else {
                let expCenter;
                for (let i = 0; i < storeMonth.length; i++) {
                    if (storeMonth[i].experienceCenterName === innerEl) {
                        expCenter = storeMonth[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenter,
                    selectedLocation: locationData,
                    tokenPercentage: selectedRevokeValue !== "" ? selectedRevokeValue : "",
                    lost: selectRevokeLost !== "" ? selectRevokeLost : "",
                    pivotValue: 'designHoldRevokeAnalysis',
                    selectedRole: selectedRevokeRole ? selectedRevokeRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    users: users ? users : "",
                    searchType: selectedRevokeSearchType ? selectedRevokeSearchType : "",
                    userLocation: userDetails.selectedLocation,
                    search: searchRevokeInput !== "" ? searchRevokeInput.toUpperCase() : "",
                    designHoldReason: designHoldReason?.length > 0 ? designHoldReason : commonDesignHoldReason,
                    designHoldStage: designHoldStage?.length > 0 ? designHoldStage : commonDesignHoldStage
                }
            }
        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDataBasedClickMonthDesignHoldRevoke(obj);
            setPopRevokeMonthData(response.data)
            setShowRevokeDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    return (
        <div className="App">
            <div>
                <Paper className={classes.paper}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={
                            userDetails?.roles && userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                            )
                                ? "flex-start"
                                : "center"
                        }
                        alignItems="center"
                    >
                        {userDetails?.roles &&
                            userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedRevokeLocation}
                                            onChange={handleRevokeMultipleLocationData}
                                            options={commonRevokeLocation}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Location"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        {userDetails?.roles &&
                            userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedRevokeExperienceCenter}
                                            onChange={handleMultipleRevokeExpData}
                                            options={revokeCommonExpCenter}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Exp-Center"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                type="date"
                                variant="outlined"
                                value={storeRevokeDateFilter.startDate}
                                onChange={storeRevokePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                value={storeRevokeDateFilter.endDate}
                                onChange={storeRevokePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button variant="contained" color="primary" onClick={handlePivotRevokeDateFilter} style={{ backgroundColor: "#F50057", color: "#fff", padding: "0.4rem 2rem 2rem 2rem" }} className={classes.submitButton} >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" alignItems="center">

                       {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst].includes(role.name))) && (revokePivot === "designHoldRevokeAnalysis") && (
                            <FormControl style={{ width: '20%', marginTop: '0.4rem', marginRight: '10px'}}>
                                <Autocomplete
                                    multiple
                                    value={designHoldStage}
                                    onChange={handleMultipleDesignHoldStage}
                                    options={commonDesignHoldStage}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Design-Hold Stage"
                                            variant="outlined"
                                        />
                                        )}
                                    />
                                </FormControl>
                          )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst].includes(role.name))) && (revokePivot === "designHoldRevokeAnalysis") && (
                           <FormControl style={{ width: '20%', marginTop: '0.4rem' }}>
                                <Autocomplete
                                    multiple
                                    value={designHoldReason}
                                    onChange={handleMultipleDesignHoldReason}
                                    options={commonDesignHoldReason}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Design-Hold Reason"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (revokePivot === 'designHoldRevokeAnalysis') && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRevokeRole}
                                            onChange={(e) => handleSelectRevokeRoles(e)}
                                            disabled={revokePivot === "lost" && !selectedRevokeDepartment}  // Disable if selectedRevokeDepartment is not set and revokePivot is "lost"
                                        >
                                            <MenuItem value={(revokePivot === "salesOverallReview" || revokePivot === "value") ? "ALL" : "ALL"}>ALL</MenuItem>
                                            <MenuItem value={(revokePivot === "salesOverallReview" || revokePivot === "value" || selectedRevokeDepartment === "Sales") ? ROLENAME.DGM_Sales : ROLENAME.DGM_Design}>DGM</MenuItem>
                                            <MenuItem value={(revokePivot === "salesOverallReview" || revokePivot === "value" || selectedRevokeDepartment === "Sales") ? ROLENAME.SalesManager : ROLENAME.OperationDesignManager}>Manager</MenuItem>
                                            <MenuItem value={(revokePivot === "salesOverallReview" || revokePivot === "value" || selectedRevokeDepartment === "Sales") ? ROLENAME.AssistantSalesManager : ROLENAME.AssistantDesignManager}>Assistant Manager</MenuItem>
                                            <MenuItem value={(revokePivot === "salesOverallReview" || revokePivot === "value" || selectedRevokeDepartment === "Sales") ? ROLENAME.SalesUser : ROLENAME.DesignUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedRevokeUsers}
                                            onChange={(e, v) => handleRevokeMultipleUsers(e, v)}
                                            options={usersRevokeData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                            disabled={revokePivot === "lost" && !selectedRevokeDepartment}  // Disable if selectedRevokeDepartment is not set and revokePivot is "lost"
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.SalesManager, ROLENAME.OperationDesignManager].includes(role.name))) && (revokePivot === 'designHoldRevokeAnalysis') && (
                            <>
                                <Grid item xs={12} sm={2}>
                                    <FormControl style={{ width: '80%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRevokeRole}
                                            onChange={(e) => handleSelectRevokeRoles(e)}
                                        >
                                            <MenuItem value={revokePivot === "value" ? "ALL" : "ALL"}>ALL</MenuItem>
                                            <MenuItem value={revokePivot === "value" ? ROLENAME.SalesManager : ROLENAME.OperationDesignManager}>Manager</MenuItem>
                                            <MenuItem value={revokePivot === "value" ? ROLENAME.AssistantSalesManager : ROLENAME.AssistantDesignManager}>Assistant Manager</MenuItem>
                                            <MenuItem value={revokePivot === "value" ? ROLENAME.SalesUser : ROLENAME.DesignUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedRevokeUsers}
                                            onChange={(e, v) => handleRevokeMultipleUsers(e, v)}
                                            options={usersRevokeData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantSalesManager, ROLENAME.AssistantDesignManager].includes(role.name))) && (revokePivot === 'designHoldRevokeAnalysis') && (
                            <>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRevokeRole}
                                            onChange={(e) => handleSelectRevokeRoles(e)}
                                        >
                                            <MenuItem value={revokePivot === "value" ? ROLENAME.AssistantSalesManager : ROLENAME.AssistantDesignManager}>Assistant Manager</MenuItem>
                                            <MenuItem value={revokePivot === "value" ? ROLENAME.SalesUser : ROLENAME.DesignUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            size="medium"
                                            value={selectedRevokeUsers}
                                            onChange={(e, v) => handleRevokeMultipleUsers(e, v)}
                                            ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                            options={usersRevokeData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                    </Grid>

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedRevokeSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleRevokeSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchRevokeTypes && searchRevokeTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchRevokeInput}
                            onChange={(e) => { setSearchRevokeInput(e.target.value) }}
                            onKeyDown={handleRevokeKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedRevokeSearchType || !searchRevokeInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleRevokeSearch(searchRevokeInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearRevokeDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            <div>
                <>
                    {/* Based On current month design-hold revoke analysis data */}
                    {(storeMonth.length != 0) &&
                        <>
                            <div
                                style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "12px", // space between buttons
                                marginTop: "10px",
                                }}
                                >
                                <Button
                                style={{
                                    backgroundColor: "#1C375D",
                                    color: "#FFF2EB",
                                    marginBottom: "6px",
                                }}
                                >
                                Design-Hold Revoke Current Month Analysis
                                </Button>

                                <CSVLink
                                    data={revokeMonthTableCsvData}
                                    filename={`Design_Hold_Revoke_Month_Analysis_${moment().format('YYYY-MM-DD')}.csv`}
                                    ref={revokeMonthTableCsvButtonRef}
                                    style={{ textDecoration: 'none', display: 'none' }}
                                />
                                <Button
                                    style={{
                                        background: "#355025",
                                        color: "#FFF2EB",
                                        marginBottom: "6px",
                                    }}
                                    icon={<DownloadOutlined />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        
                                        const csvData = generateRevokeMonthTableCsvData();

                                        if (csvData.length > 0) {
                                            setRevokeMonthTableCsvData(csvData);
                                            setTimeout(() => {
                                                setTriggerRevokeMonthDownload(true);
                                            }, 100);
                                        } else {
                                            props?.setSnackInfo("No data available to export", "warning");
                                        }
                                    }}
                                >
                                    Download CSV
                                </Button>
                                </div>

                            <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                                <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                                    <Table style={{ minWidth: '600px' }}>
                                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>Revoke Month</StyledTableCell>
                                                {storeMonth.slice(0, uniqueexperienceCenterCodeMonth.length - 1).map((experienceCenterName, index) => (
                                                    <StyledTableCell
                                                        colspan={2}
                                                        className={classes.bordercolors}
                                                        key={index}
                                                        style={{
                                                            fontSize: index === uniqueexperienceCenterNamesMonth.length - 1 ? '15px' : '13px',
                                                            fontWeight: index === uniqueexperienceCenterNamesMonth.length - 1 ? 'bolder' : 'normal',
                                                            textAlign: 'center',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                            <span style={{ cursor: "pointer" }}>
                                                                {experienceCenterName.expCenterCode}
                                                            </span>
                                                        </Tooltip>
                                                    </StyledTableCell>
                                                ))}
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }} colspan={2}>
                                                    Grand Total
                                                </StyledTableCell>
                                            </StyledTableRow>
                                            <StyledTableRow>
                                                {storeMonth?.slice(0, uniqueexperienceCenterCodeMonth?.length - 1)?.map((experienceCenterName, index) => (
                                                    <>
                                                        <StyledTableCell>Count</StyledTableCell>
                                                        <StyledTableCell>Value</StyledTableCell>
                                                    </>
                                                ))}
                                                <StyledTableCell>Count</StyledTableCell>
                                                <StyledTableCell>Value</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>

                                        <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                            {storeMonth[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                                <StyledTableRow key={monthIndex}>
                                                    <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, textAlign: "center" }}>
                                                        {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                                    </StyledTableCell>

                                                    {uniqueexperienceCenterNamesMonth.map((experienceCenterName, expCenterIndex) => (
                                                        <>
                                                            {expCenterDataMonth[experienceCenterName].map((innerEl, dataIndex) => (
                                                                <>
                                                                    <StyledTableCell
                                                                        className={classes.bordercolors}
                                                                        key={dataIndex}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            cursor: "pointer",
                                                                            top: 0,
                                                                            background: "white",
                                                                            textDecoration: 'underline',
                                                                            fontWeight: expCenterIndex === uniqueexperienceCenterNamesMonth.length - 1 ? 'bolder' : 'normal',
                                                                            color: expCenterIndex === uniqueexperienceCenterNamesMonth.length - 1 ? "#355025" : "#1C375D"
                                                                        }}
                                                                        onClick={(e) => getDataBasedOnClickMonthCount(e, month, innerEl, 'value')}
                                                                    >
                                                                        {
                                                                            formatNumberToTwoDecimalPlaces(
                                                                                innerEl.monthlyGrandTotal.find(
                                                                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                                )?.count || 0
                                                                            )
                                                                        }
                                                                    </StyledTableCell>
                                                                    <StyledTableCell
                                                                        className={classes.bordercolors}
                                                                        key={dataIndex}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            cursor: "pointer",
                                                                            top: 0,
                                                                            textDecoration: "underline",
                                                                            background: "white",
                                                                            fontWeight: expCenterIndex === uniqueexperienceCenterNamesMonth.length - 1 ? 'bolder' : 'normal',
                                                                            color: expCenterIndex === uniqueexperienceCenterNamesMonth.length - 1 ? "#355025" : "#1C375D"
                                                                        }}
                                                                        onClick={(e) => getDataBasedOnClickMonthCount(e, month, innerEl, 'value')}
                                                                    >
                                                                         {
                                                                            formatNumberToTwoDecimalPlaces(
                                                                                innerEl.monthlyGrandTotal.find(
                                                                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                                )?.totalGrandTotal || 0
                                                                            )
                                                                        }
                                                                    </StyledTableCell>
                                                                </>
                                                            ))}
                                                        </>
                                                    ))}
                                                </StyledTableRow>
                                            ))}

                                            <StyledTableRow>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Grand Total</StyledTableCell>
                                                {uniqueexperienceCenterNamesMonth.map((experienceCenterName, index) => (
                                                    <>
                                                        <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }}
                                                              onClick={(e) => getDataBasedOnClickMonthCount(e, storeMonth[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                            {
                                                                formatNumberToTwoDecimalPlaces(storeMonth.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.count : 0), 0))
                                                            }
                                                        </StyledTableCell>
                                                        <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }}
                                                               onClick={(e) => getDataBasedOnClickMonthCount(e, storeMonth[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                            {
                                                                formatNumberToTwoDecimalPlaces(storeMonth.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.grandTotal : 0), 0))
                                                            }
                                                        </StyledTableCell>
                                                    </>
                                                ))}
                                            </StyledTableRow>
                                        </TableHead>
                                    </Table>
                                </TableContainer>
                            </div>
                        </>
                    }

                {(revokeStore.length != 0) &&
                    <>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2} >
                            <Button
                                style={{
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',
                                    marginBottom: '6px',
                                    marginTop: '20px'
                                }}
                            >
                            Design-Hold Revoke Year Analysis
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <CSVLink
                                data={revokeYearTableCsvData}
                                filename={`Design_Hold_Revoke_Year_Analysis_${moment().format('YYYY-MM-DD')}.csv`}
                                ref={revokeYearTableCsvButtonRef}
                                style={{ textDecoration: 'none', display: 'none' }}
                            />
                            <Button
                                style={{
                                    background: "#355025",
                                    color: "#FFF2EB",
                                    marginBottom: '6px',
                                    marginTop: '20px',
                                    marginLeft: '20px',
                                }}
                                icon={<DownloadOutlined />}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    
                                    const csvData = generateRevokeYearTableCsvData();

                                    if (csvData.length > 0) {
                                        setRevokeYearTableCsvData(csvData);
                                        setTimeout(() => {
                                            setTriggerRevokeYearDownload(true);
                                        }, 100);
                                    } else {
                                        props?.setSnackInfo("No data available to export", "warning");
                                    }
                                }}
                            >
                                Download CSV
                            </Button>
                        </Grid>
                    </Grid>
                        <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                                <Table style={{ minWidth: '600px' }}>
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>Revoke Year</StyledTableCell>
                                            {revokeStore?.slice(0, uniqueexperienceCenterRevokeCode?.length - 1)?.map((experienceCenterName, index) => (
                                                <>
                                                    <StyledTableCell
                                                        colSpan={2}
                                                        className={classes.bordercolors}
                                                        key={index}
                                                        style={{
                                                            fontSize: index === uniqueexperienceCenterRevokeNames?.length - 1 ? '15px' : '13px',
                                                            fontWeight: index === uniqueexperienceCenterRevokeNames?.length - 1 ? 'bolder' : 'normal',
                                                            textAlign: 'center',
                                                            position: 'sticky',
                                                            cursor: 'pointer',
                                                            top: 0,
                                                            zIndex: 1, // Ensure the same zIndex for all cells
                                                        }}
                                                    >
                                                        <Tooltip title={`${experienceCenterName?.experienceCenterName}-${experienceCenterName?.expCtrCityName}`} placement="top">
                                                            <span style={{ cursor: "pointer" }}>
                                                                {experienceCenterName?.expCenterCode}
                                                            </span>
                                                        </Tooltip>
                                                    </StyledTableCell>
                                                </>

                                            ))}
                                            <StyledTableCell colspan={2} className={classes.bordercolors} style={{ textAlign: "center" }}>
                                                Grand Total
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        {/* count value row */}
                                        <StyledTableRow>
                                            {revokeStore?.slice(0, uniqueexperienceCenterRevokeCode?.length - 1)?.map((experienceCenterName, index) => (
                                                <>
                                                    <StyledTableCell>Count</StyledTableCell>
                                                    <StyledTableCell>Value</StyledTableCell>
                                                </>
                                            ))}
                                            <StyledTableCell>Count</StyledTableCell>
                                            <StyledTableCell>Value</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>

                                    <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {revokeStore[grandTotalIndex]?.yearlyGrandTotal?.map((month, monthIndex) => (
                                            <StyledTableRow key={monthIndex}>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, textAlign: "center", cursor: "pointer" }}>
                                                            <div>
                                                            <Button
                                                                 style={{
                                                                    border: 'none',
                                                                    cursor: 'pointer', 
                                                                    background: 'transparent',
                                                                    color: 'white',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickDesignHoldRevoke(e, month, innerElYearDate, 'designHoldRevokeAnalysis')}
                                                            >
                                                              {`${month.year} - (Jan-Dec)`} 
                                                            </Button>
                                                            </div>
                                                </StyledTableCell>
                                                {uniqueexperienceCenterRevokeNames.map((experienceCenterName, expCenterIndex) => (
                                                    <>
                                                        {expCenterRevokeData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <>
                                                                <StyledTableCell
                                                                    className={classes.bordercolors}
                                                                    key={dataIndex}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        cursor: "pointer",
                                                                        top: 0,
                                                                        textDecoration: "underline",
                                                                        background: "white",
                                                                        fontWeight: expCenterIndex === uniqueexperienceCenterRevokeNames.length - 1 ? 'bolder' : 'normal',
                                                                        color: expCenterIndex === uniqueexperienceCenterRevokeNames.length - 1 ? "#355025" : "#1C375D"
                                                                    }}
                                                                    onClick={(e) => getDataBasedOnClickDesignHoldRevoke(e, month, innerEl, 'designHoldRevokeAnalysis')}
                                                                >
                                                                    {
                                                                        formatNumberToTwoDecimalPlaces(
                                                                            innerEl.yearlyGrandTotal.find(
                                                                                (entry) => entry.year === month.year
                                                                            )?.count || 0
                                                                        )
                                                                    }
                                                                </StyledTableCell>
                                                                <StyledTableCell
                                                                    className={classes.bordercolors}
                                                                    key={dataIndex}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        cursor: "pointer",
                                                                        top: 0,
                                                                        textDecoration: "underline",
                                                                        background: "white",
                                                                        fontWeight: expCenterIndex === uniqueexperienceCenterRevokeNames.length - 1 ? 'bolder' : 'normal',
                                                                        color: expCenterIndex === uniqueexperienceCenterRevokeNames.length - 1 ? "#355025" : "#1C375D"
                                                                    }}
                                                                    onClick={(e) => getDataBasedOnClickDesignHoldRevoke(e, month, innerEl, 'designHoldRevokeAnalysis')}
                                                                >
                                                                    {
                                                                        formatNumberToTwoDecimalPlaces(
                                                                            innerEl.yearlyGrandTotal.find(
                                                                                (entry) => entry.year === month.year
                                                                            )?.totalGrandTotal || 0
                                                                        )
                                                                    }
                                                                </StyledTableCell>
                                                            </>
                                                        ))}
                                                    </>
                                                ))}
                                            </StyledTableRow>
                                        ))}

                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Grand Total</StyledTableCell>
                                            {uniqueexperienceCenterRevokeNames?.map((experienceCenterName, index) => (
                                                <>
                                                    <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClickDesignHoldRevoke(e, revokeStore[grandTotalIndex]?.yearlyGrandTotal, experienceCenterName, 'revokeTotal')}>
                                                        {
                                                            formatNumberToTwoDecimalPlaces(revokeStore?.reduce((total, el) => total + (el?.experienceCenterName === experienceCenterName ? el?.count : 0), 0))
                                                        }
                                                    </StyledTableCell>
                                                    <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClickDesignHoldRevoke(e, revokeStore[grandTotalIndex]?.yearlyGrandTotal, experienceCenterName, 'revokeTotal')}>
                                                        {
                                                            formatNumberToTwoDecimalPlaces(revokeStore?.reduce((total, el) => total + (el?.experienceCenterName === experienceCenterName ? el?.grandTotal : 0), 0))
                                                        }
                                                    </StyledTableCell>
                                                </>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>
                    </>
                }
                </> 
            </div>
            <Modal
                title={revokePivot}
                centered
                visible={showRevokeDetailedModal}
                onCancel={() => setShowRevokeDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        revokeHeaders={revokeHeaders}
                        filename={`${revokePivot}.csv`}
                        data={csvrevokeData}
                        ref={csvRevokeButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadRevokeHandler(popRevokeMonthData)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB", marginRight: '10px' }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popRevokeMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design-Hold Stage</StyledTableCell>
                                    <StyledTableCell>Design-Hold Reason</StyledTableCell>
                                    <StyledTableCell>Probable Date for Restarting the Designing</StyledTableCell>
                                    <StyledTableCell>Probable Date of Design Sign-off</StyledTableCell>
                                    <StyledTableCell>ADM</StyledTableCell>
                                    <StyledTableCell>Operation Design Manager</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popRevokeMonthData && popRevokeMonthData.map((data, i) => {
                                    return (
                                        <>
                                            <StyledTableRow key={i}>
                                                <StyledTableCell>{i + 1}</StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.erpProjectNo ? (
                                                        <Link
                                                            to={`/project-logs/${data?.leadId?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.leadId?.erpProjectNo}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?.leadId?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.leadId?.lead_no}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.customerId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadId?.staticSalesWonBudget ? data?.leadId?.staticSalesWonBudget : "N/A"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.salesExpCenter?.locationId?.name }
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.salesExpCenter?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.SalesWonDate ? moment(data?.SalesWonDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadId?.designStatus ? data?.leadId?.designStatus : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadId.designHoldSelectedTypes ? data?.leadId?.designHoldSelectedTypes : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadId?.proposedDesignStartDate ? moment(data?.leadId?.proposedDesignStartDate).format("DD-MM-YYYY") : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadId?.probableDesignSignOffDate ? moment(data?.leadId?.probableDesignSignOffDate).format("DD-MM-YYYY") : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.designAssistantManager?.name ? data?.designAssistantManager?.name : 'NA'}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.designManager ? data.designManager.name : 'NA'}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(DesignHoldRevokeAnalysis);